import axios from "axios"
import { port } from "../CommonComponents/CommonWorkers";

console.log(process.env.NODE_ENV) 
let address = window.location.protocol + "//" + window.location.hostname + port + "/api"
const isDebug = process.env.NODE_ENV === "development" ? true : false;
if(isDebug) {
    address = window.location.protocol + "//" + "prs2.myproxy.club" + port
    // address = window.location.protocol + "//" + "172.22.10.14" + port
}
export const getContent = async (id) =>{
    const content = (await axios.get(`${address}/site/getContent`,{params: {id: id}})).data;
    return content;
}

export const getContentMenu = async () =>{
    const contentMenu = (await axios.get(`${address}/site/getContentMenu`)).data;
    return contentMenu;
}


export const createArticle = async (parentId = "", header = "TestHeader", content) =>{
    const contentId = (await axios.post(
        `${address}/site/createArticle`,
        {
            parentId: parentId,
            header: header,
            content: content
        })
        ).data;
    console.log(contentId)
    return contentId;
}

export const updateArticle = async (id, parentId, header = "TestHeader", content) =>{
    const contentId = (await axios.post(
        `${address}/site/updateArticle`,
        {
            id: id,
            parentId: parentId,
            header: header,
            content: content
        })
        ).data;
    console.log(contentId)
    return contentId;
}

export const updateArticleTitle = async (id, parentId, header) =>{
    const contentId = (await axios.post(
        `${address}/site/updateArticleTitle`,
        {
            id: id,
            parentId: parentId,
            header: header
        })
        ).data;
    console.log(contentId)
    return contentId;
}
export const articleMove = async (id, curs) =>{
    const contentId = (await axios.post(
        `${address}/site/articleMove`,
        {
            id: id,
            curs: curs,
        })
        ).data;
    console.log(contentId)
    return contentId;
}

export const addToSelectedArticles = async (id) =>{
    const contentId = (await axios.post(
        `${address}/site/selectArticle`,
        {
            id: id,
        })
        ).data;
    console.log(contentId)
    return contentId;
}

export const getLinks = async (id) =>{
    const content = (await axios.post(
        `${address}/site/getLinks`,
        {
            id: id,
        })
        ).data;
    console.log(content)
    return content;
}

export const addLink = async (idMaster, idSlave) =>{
    const content = (await axios.post(
        `${address}/site/addLink`,
        {
            idMaster: idMaster,
            idSlave: idSlave,
        })
        ).data;
    console.log(content)
    return content;
}

export const deleteLink = async (idMaster, idSlave) =>{
    const content = (await axios.post(
        `${address}/site/deleteLink`,
        {
            idMaster: idMaster,
            idSlave: idSlave,
        })
        ).data;
    console.log(content)
    return content;
}
export const moveRecToParent = async (id, parentId) => {
    const res = (await axios.post(`${address}/site/moveRecToParent`, {id: id, parentId: parentId})).data
    return res;
}
export const deleteArticle = async (id) =>{
    await axios.post(`${address}/site/deleteArticle`,{id: id,})
}
export const getDateTimeFromISOString = (isoDate) => {
    if (!isoDate) {
        return [null, null];
    }
    let date = new Date(isoDate).toLocaleDateString();
    let time = new Date(isoDate).toLocaleTimeString();
    return [date, time];
};
